import fetch from '@/utils/fetch';
import store from '@/vuex';

export function soyoungWxAuthGetWxSessionInfo(code) {
  return fetch.post(`/wxopen-proxy/api/soyoungWxAuth/getWxSessionInfo?jsCode=${code}`);
}

export function alipayMemberAuthLoginByCode(code) {
  // 支付宝 userid
  return fetch.post(`/shopmember/api/alipay/memberAuth/loginByCode?code=${code}`);
}

export function soyoungWxAuthDecode(iv, encryptedData) {
  const { openId } = store.state;
  return fetch.post(
    `/wxopen-proxy/api/soyoungWxAuth/decode?iv=${encodeURIComponent(
      iv
    )}&encryptedData=${encodeURIComponent(encryptedData)}&openid=${openId}`
  );
}
// 公众号网页授权后获取用户信息
export function soyoungWxAuthGetUserinfoOffAccount(code) {
  return fetch.post(`/wxopen-proxy/api/soyoungWxAuth/getUserinfoOffAccount?jsCode=${code}`);
}
















export function soyoungWxAuthJssign(url = location.href.split('#')[0]) {
  // h5 微信公众号 界面js调用微信接口时，提供获取签名的接口
  return fetch.post('/wxopen-proxy/api/soyoungWxAuth/jssign', { url });
}


// 获取urlSceme
export function getOpenLink(data) {
  return fetch.post('/wxopen-proxy/api/wxopen/getOpenLink', data);
}

// 获取微信urlScheme 该接口不需要登录态
export function getOpenLinkOfNoToken(data) {
  return fetch.post('/newretail/api/shortUrl/generateWxUrlScheme', data);
}


//  app 获取客服链接
export function getWxCustomerServiceLink() {
  return fetch.get(`/chat-service/api/wxCustomerServiceLink/getMyLink`);
}
//  app 判断是否启用新客服链接
export function checkCustomerEnable() {
  return fetch.get(`/chat-service/api/wxCustomerServiceSecret/checkEnable`);
}
export function soyoungWxAuthGetMpOpenId(jsCode) {
  // 水羊公众号-H5获取用户openId
  return fetch.post('/wxopen-proxy/api/soyoungWxAuth/getMpOpenId?jsCode=' + jsCode);
}
